"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var root = require("window-or-global");
var lodash_1 = require("lodash");
var cruiseDetail_1 = require("./searching/cruiseDetail");
exports.default = {
    computed: {
        showPixels: function () {
            return this.$store.getters['tracking/bea/trackingPixelActivated'];
        },
    },
    render: function (h) {
        if (!this.showPixels) {
            return;
        }
        var trackingPixels = lodash_1.map(cruiseDetail_1.default, h);
        var pxlWrapperAttrs = { style: { display: 'none', width: 0, height: 0 } };
        return h('div', pxlWrapperAttrs, trackingPixels);
    },
    mounted: function () {
        var _this = this;
        if (root.isClient) {
            var activatePixel = function () {
                return _this.$store.dispatch('tracking/bea/activateTrackingPixels');
            };
            setTimeout(activatePixel, 500);
        }
    },
};
//# sourceMappingURL=pixels.js.map